import { Component, ElementRef, HostListener } from '@angular/core';

@Component({
  selector: 'app-contact-sideswipe',
  templateUrl: './contact-sideswipe.component.html',
  styleUrls: ['./contact-sideswipe.component.scss'],
})
export class ContactSideswipeComponent {
  isContactOpen = false;

  constructor(private elementRef: ElementRef) {}

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent) {
    if (!this.elementRef) return;
    // Check if the click target is outside the component
    const isClickedOutside = !this.elementRef.nativeElement.contains(
      event.target
    );
    if (isClickedOutside) this.closeContact();
  }

  openContact() {
    this.isContactOpen = !this.isContactOpen;
  }

  closeContact() {
    if (this.isContactOpen) this.isContactOpen = !this.isContactOpen;
  }
}
